import Axios from "axios";
import { API_URL } from "../config";

// Codes de refus renvoyés par l'API pour un lien reçu par e-mail (PER-2509).
export const REFUS_LIEN = {
  DEJA_UTILISE: "JETON_DEJA_UTILISE",
  EXPIRE: "JETON_EXPIRE",
  INCONNU: "JETON_INCONNU",
};

// L'API n'a pas répondu, ou a répondu par une erreur serveur : le lien n'est pas en cause.
export const INDISPONIBLE = "INDISPONIBLE";

// Vérifie le lien SANS le consommer. Un robot ou l'antivirus d'une messagerie qui ouvre la
// page ne grille donc plus le lien : seul le clic du client le consomme.
export const verifierLien = (token) =>
  Axios.post(API_URL + "tokens/renew-password", { token });

// Code de refus porté par une erreur Axios. Une réponse 4xx sans code (API antérieure à
// PER-2509) est traitée comme un lien non valide.
export const codeRefus = (err) => {
  const reponse = err && err.response;
  if (!reponse || reponse.status >= 500) return INDISPONIBLE;
  return (reponse.data && reponse.data.code) || REFUS_LIEN.INCONNU;
};
